module.exports = __webpack_public_path__ + "static/character-behaviour-ec48b4e2a13dd4382599019e0d5724fe.jpg";